import React from 'react';
import { Link } from 'react-router';
import { Button } from '../../../components/Button';
import { Section } from '../../../components/Section';

export const GetInTouch: React.FC = () => {
  return (
    <Section style={{ backgroundColor: 'var(--panel)' }}>
      <div
        style={{
          textAlign: 'center',
          padding: '48px 24px',
        }}
      >
        <h2
          style={{
            fontSize: '34px',
            fontWeight: 700,
            color: 'var(--text)',
            marginBottom: '16px',
          }}
          className="sectionTitle"
        >
          Get In Touch
        </h2>
        <p
          style={{
            fontSize: '18px',
            color: 'var(--muted)',
            marginBottom: '32px',
            maxWidth: '600px',
            margin: '0 auto 32px',
            lineHeight: 1.6,
          }}
        >
          Want to join the founding network?
        </p>
        <div
          style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Link to="/membership" style={{ textDecoration: 'none' }}>
            <Button variant="primary">Join Waitlist</Button>
          </Link>
          <Link to="/contact" style={{ textDecoration: 'none' }}>
            <Button variant="secondary">Contact Us</Button>
          </Link>
        </div>
      </div>
    </Section>
  );
};

